import { render, staticRenderFns } from "./PartnerEstablishmentPermissionsModal.vue?vue&type=template&id=3d6f652b&scoped=true"
import script from "./PartnerEstablishmentPermissionsModal.vue?vue&type=script&lang=js"
export * from "./PartnerEstablishmentPermissionsModal.vue?vue&type=script&lang=js"
import style0 from "./PartnerEstablishmentPermissionsModal.vue?vue&type=style&index=0&id=3d6f652b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6f652b",
  null
  
)

export default component.exports